var _rect, _g, _g2, _g3, _rect2, _rect3, _g4, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _path, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _g5, _g6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSonicAdvantageTeaser03Small(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 326 354",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 326,
    height: 354,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 354,
    height: 326,
    x: 326,
    fill: "#fff",
    rx: 28,
    transform: "rotate(90 326 0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.295,
    cy: -165.673,
    fill: "url(#b)",
    rx: 339.827,
    ry: 414.705,
    transform: "rotate(90 162.295 -165.673)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 234.833,
    height: 174.43,
    x: 45.582,
    y: 40,
    fill: "#fff",
    rx: 4.931
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    fillOpacity: 0.4,
    d: "M271.17 59.724H115.848a7.089 7.089 0 0 1-7.089-7.089v-.924a7.396 7.396 0 0 0-7.396-7.396H60.375a7.396 7.396 0 0 0-7.396 7.396v4.314a3.698 3.698 0 0 1-3.698 3.699 1.85 1.85 0 0 0-1.85 1.849V204.27a7.396 7.396 0 0 0 7.387 7.396l216.343.289a7.397 7.397 0 0 0 7.406-7.397V67.12a7.397 7.397 0 0 0-7.397-7.396Z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 50.539,
    height: 9.861,
    x: 55.443,
    y: 46.78,
    fill: "#fff",
    rx: 4.931
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 3.698,
    height: 3.698,
    x: 99.203,
    y: 49.862,
    fill: "#EAEAEA",
    rx: 1.849
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#f)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 294.004,
    height: 11.711,
    x: 15.996,
    y: 208.883,
    fill: "#fff",
    rx: 4.931
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 62.249,
    height: 12.326,
    x: 55.443,
    y: 115.196,
    fill: "#fff",
    rx: 6.163
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 62.249,
    height: 12.326,
    x: 55.443,
    y: 158.958,
    fill: "#fff",
    rx: 6.163
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 62.249,
    height: 4.314,
    x: 55.443,
    y: 131.222,
    fill: "#fff",
    rx: 2.157
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 89.983,
    height: 4.314,
    x: 55.443,
    y: 138.001,
    fill: "#fff",
    rx: 2.157
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 42.525,
    height: 4.314,
    x: 55.443,
    y: 144.781,
    fill: "#fff",
    rx: 2.157
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 62.249,
    height: 12.326,
    x: 55.443,
    y: 71.434,
    fill: "#fff",
    rx: 6.163
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 62.249,
    height: 4.314,
    x: 55.443,
    y: 87.459,
    fill: "#fff",
    rx: 2.157
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 89.983,
    height: 4.314,
    x: 55.443,
    y: 94.239,
    fill: "#fff",
    rx: 2.157
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 42.525,
    height: 4.314,
    x: 55.443,
    y: 101.019,
    fill: "#fff",
    rx: 2.157
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 62.249,
    height: 4.314,
    x: 55.443,
    y: 174.983,
    fill: "#fff",
    rx: 2.157
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 89.983,
    height: 4.314,
    x: 55.443,
    y: 181.763,
    fill: "#fff",
    rx: 2.157
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 42.525,
    height: 4.314,
    x: 55.443,
    y: 188.543,
    fill: "#fff",
    rx: 2.157
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0F0F26",
    d: "M162.074 59.107h116.489v149.771H162.074z"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 62.249,
    height: 12.326,
    x: 175.635,
    y: 71.434,
    fill: "#fff",
    opacity: 0.1,
    rx: 6.163
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 62.249,
    height: 12.326,
    x: 175.635,
    y: 115.196,
    fill: "#fff",
    opacity: 0.1,
    rx: 6.163
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 62.249,
    height: 12.326,
    x: 175.635,
    y: 158.958,
    fill: "#fff",
    opacity: 0.1,
    rx: 6.163
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 62.249,
    height: 4.314,
    x: 175.635,
    y: 131.222,
    fill: "#fff",
    opacity: 0.1,
    rx: 2.157
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 89.983,
    height: 4.314,
    x: 175.635,
    y: 138.001,
    fill: "#fff",
    opacity: 0.1,
    rx: 2.157
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 42.525,
    height: 4.314,
    x: 175.635,
    y: 144.782,
    fill: "#fff",
    opacity: 0.1,
    rx: 2.157
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 62.249,
    height: 4.314,
    x: 175.635,
    y: 87.46,
    fill: "#fff",
    opacity: 0.1,
    rx: 2.157
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 89.983,
    height: 4.314,
    x: 175.635,
    y: 94.24,
    fill: "#fff",
    opacity: 0.1,
    rx: 2.157
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 42.525,
    height: 4.314,
    x: 175.635,
    y: 101.02,
    fill: "#fff",
    opacity: 0.1,
    rx: 2.157
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    width: 62.249,
    height: 4.314,
    x: 175.635,
    y: 174.983,
    fill: "#fff",
    opacity: 0.1,
    rx: 2.157
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    width: 89.983,
    height: 4.314,
    x: 175.635,
    y: 181.763,
    fill: "#fff",
    opacity: 0.1,
    rx: 2.157
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    width: 42.525,
    height: 4.314,
    x: 175.635,
    y: 188.544,
    fill: "#fff",
    opacity: 0.1,
    rx: 2.157
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#g)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.443,
    height: 39.443,
    x: 205.217,
    y: 113.963,
    fill: "#0A0A1A",
    rx: 4.931
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.644,
    d: "M232.334 134.335a7.393 7.393 0 0 1-8.974 6.538 7.396 7.396 0 0 1 .929-14.582 5.744 5.744 0 0 0-1.11 3.846 5.754 5.754 0 0 0 9.155 4.198Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#h)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.443,
    height: 39.443,
    x: 80.715,
    y: 110.265,
    fill: "#fff",
    rx: 4.931
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.644,
    clipPath: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.437 134.097a4.108 4.108 0 1 0 0-8.217 4.108 4.108 0 1 0 0 8.217ZM100.439 120.949v1.643M100.439 137.385v1.643M94.045 123.595l1.167 1.167M105.666 135.215l1.167 1.167M91.398 129.989h1.644M107.834 129.989h1.643M94.045 136.382l1.167-1.167M105.666 124.762l1.167-1.167"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: 259.488,
    height: 199.084,
    x: 33.255,
    y: 30.138,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.465
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.164
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_301_7523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_301_7523",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    width: 236.066,
    height: 172.571,
    x: 44.966,
    y: 41.849,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.233
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_301_7523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_301_7523",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f",
    width: 318.658,
    height: 36.365,
    x: 3.669,
    y: 199.022,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.465
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.164
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_301_7523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_301_7523",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "g",
    width: 64.098,
    height: 64.098,
    x: 192.89,
    y: 104.101,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.465
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.164
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_301_7523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_301_7523",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "h",
    width: 64.098,
    height: 64.098,
    x: 68.388,
    y: 100.403,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.465
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.164
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_301_7523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_301_7523",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 464.639,
    x2: -219.704,
    y1: -165.904,
    y2: -77.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B21C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.946,
    stopColor: "#D885FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 162.999,
    x2: 162.999,
    y1: 44.315,
    y2: 211.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3866C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3866C2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M90.576 120.127h19.722v19.722H90.576z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSonicAdvantageTeaser03Small);
export default __webpack_public_path__ + "static/media/sonic-advantage-teaser-03-small.ce74794f56d4724d3ba836c037efa01a.svg";
export { ForwardRef as ReactComponent };